export const LOADER_TIPS = [
  "Did you know? The average person spends about 6 months of their lifetime waiting for red lights.",
  "Pro tip: Use keyboard shortcuts to navigate faster through your application.",
  "Remember to take regular breaks to maintain productivity.",
  "The best way to predict the future is to create it.",
  "Small progress is still progress.",
  "Every expert was once a beginner.",
  "Stay focused on your goals, even when progress seems slow.",
  "Success is not final, failure is not fatal: it is the courage to continue that counts.",
  "The only way to do great work is to love what you do.",
  "Your time is limited, don't waste it living someone else's life.",
  "The journey of a thousand miles begins with one step.",
  "Patience is not the ability to wait, but the ability to keep a positive attitude while waiting.",
  "Focus on the journey, not the destination.",
  "Every moment is a fresh beginning.",
  "The only limit to our realization of tomorrow will be our doubts of today."
]; 